import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-busy',
  templateUrl: './busy.component.html',
  styleUrls: ['./busy.component.scss'],
})
export class BusyComponent {
  constructor() {}

  private _iconClass: string = 'pbi-icon-mini pbi-loader-circle spin text-primary';

  public get iconClass(): string {
    return this._iconClass;
  }

  @Input()
  public set iconClass(className: string) {
    this._iconClass = 'pbi-icon-mini pbi-loader-circle spin text-primary ' + className;
  }
}
